define('app/views/on_map_view',['app/setup', 'mighty-slider'], function (takhfifan) {

  takhfifan.OnMapView = Backbone.View.extend({

    events: {
      'click .tkh-on-map__toggle-deals': 'toggleDeals',
      'change .tkh-map-filter-item' : 'filterDeals',
      'click .tkh-on-map__toggle-filters': 'toggleFilters'
    },

    dealsTemplate: ( $('#on-map-deals-template').length > 0 ) ?
      _.template($('#on-map-deals-template').html()) : '',

    filtersTemplate: ( $('#on-map-filters-template').length > 0 ) ?
      _.template($('#on-map-filters-template').html()) : '',

    initialize: function () {
      this.userLocation = [35.7248, 51.3817];
      this.map = undefined;
      this.circleArea = undefined;
      this.deals = [];
      this.nearByDeals = [];
      this.categories = [];
      this.markers = [];
      this.navigationType = this.$el.data('navType');
      this.circleRadius = this.$el.data('circleRadius');
      this.maxDeal = this.$el.data('maxDeal');
      this.$delasWrapper = this.$('.tkh-on-map__deals');
      this.$filtersWrapper = this.$('.tkh-on-map__filters');

      var height = 'calc(100vh - ' + this.$el[0].getBoundingClientRect().top + 'px)';
      this.$el.css('height', height);

      this.loadMap();
      this.getDeals();

      var _this = this;

      $(window).resize(function () {
        _this.$slider && _this.$slider.set({
          navigation: {
            slideSize: _this._calculateSlideSize()
          }
        });
        var height = 'calc(100vh - ' + _this.$el[0].getBoundingClientRect().top + 'px)';
        _this.$el.css('height', height);
      });
    },

    filterDeals: function (e) {
      var selectedCats = [];
      $('.tkh-map-filter-item:checked').each(function(item){
        selectedCats.push(parseInt($(this).val(),10))
      });
      this.filters = selectedCats;
      this.showNearbyDeals();
    },

    getDeals: function () {
      var _this = this;
      $.ajax({
        type: 'GET',
        url: '/ajax/product/geoCityDeals',
        data: {
          form_key: takhfifan.formKey
        }
      }).done(function (data) {
        _this.baseLocation = data.location;
        _this.deals = data.deals;
        _this.categories = data.categories;

        _.each(_this.deals, function(deal) {
          _.every(_this.categories, function(cat) {
            if(_.indexOf(deal.categories, cat.id) === -1){
              return true;
            }
            deal.type = cat.typeName;
            return false;
          });
        });

        _this.userLocation = [data.location.lat, data.location.lng];
        _this.showFilters();
        if (_this.map) {
          var latLng = new google.maps.LatLng(_this.userLocation[0], _this.userLocation[1]);
          _this.map.setCenter(latLng);
          _this.showNearbyDeals();
        }
      }).fail(function () {
        console.log('something is wrong...');
      }).always(function () {
      });
    },

    showFilters: function () {
      if (!this.categories) {
        this.$filtersWrapper.html('');
        return;
      }
      var _this = this;
      this.$filtersWrapper.html(this.filtersTemplate({cats: this.categories}));
      this.filters = [];
      $('.tkh-map-filter-item:checked').each(function(){
        _this.filters.push(parseInt($(this).val(),10))
      });

    },

    loadMap: function () {
      var _this = this,
        srcParams = "sensor=false";

      srcParams += "&key=" + this.$el.data('key');
      this.geoFindLocation();

      require(["async!https://maps.googleapis.com/maps/api/js?" + srcParams + "!callback"], function () {
        var latLng = new google.maps.LatLng(_this.userLocation[0], _this.userLocation[1]),
          mapOptions = {
            zoom: 15,
            center: latLng,
            scrollwheel: true,
            mapTypeControl: false,
            navigationControl: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            minZoom: 11,
            maxZoom: 17
          },
          $mapCanvas = _this.$('.tkh-map-canvas');
        _this.map = new google.maps.Map($mapCanvas[0], mapOptions);
        _this.showNearbyDeals();

        _this.map.addListener('dragend', function () {
          var center = _this.map.getCenter();
          _this.userLocation = [center.lat(), center.lng()];
          _this.showNearbyDeals();
        });

      });
    },

    geoFindLocation: function () {
      var _this = this;
      if (!navigator.geolocation) {
        return;
      }

      navigator.geolocation.getCurrentPosition(function (position) {
          _this.userLocation = [position.coords.latitude, position.coords.longitude];
          if (_this.map) {
            var latLng = new google.maps.LatLng(_this.userLocation[0], _this.userLocation[1]);
            _this.map.setCenter(latLng);
            _this.showNearbyDeals();
          }
        }, function (data) {
          console.log(data);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 5000
        });
    },

    showNearbyDeals: function () {
      var _this = this,
        countOfDeals = 0,
        radius = this.circleRadius,
        maximumDeal = this.maxDeal;

      //clear the map
      this.nearByDeals = [];
      for (i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
        this.markers[i] = null;
        delete this.markers[i];
      }
      this.markers = [];
      if (this.circleArea) {
        this.circleArea.setMap(null);
      }

      filteredDeals = _.filter(this.deals, function(deal){
        return _.intersection(deal.categories, _this.filters).length;
      });

      if (this.navigationType === "circle") {
        this.nearByDeals = _.filter(filteredDeals, function (deal) {
          if (countOfDeals < maximumDeal && _this._distance(deal.lat, deal.lng) < radius / 1000) {
            countOfDeals++;
            return true
          }
          return false;
        });
      } else {
        this.nearByDeals = _.first(_.sortBy(filteredDeals, function (deal) {
          return _this._distance(deal.lat, deal.lng);
        }), 10);
      }

      this.initSlider();

      var bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < this.nearByDeals.length; i++) {
        (function (num) {
          var position = new google.maps.LatLng(_this.nearByDeals[num]['lat'], _this.nearByDeals[num]['lng']);
          bounds.extend(position);
          var markerMap = _this.map;
          var marker = new google.maps.Marker({
            position: position,
            icon : {
              url: "/skin/frontend/v3/default/images/map/" + _this.nearByDeals[num]['type'] +".svg",
              scaledSize: new google.maps.Size(32, 44),
              origin: new google.maps.Point(0,0),
              anchor: new google.maps.Point(0, 0)
            },
            map: markerMap,
            title: _this.nearByDeals[num]['title'],
            id: _this.nearByDeals[num]['id']
          });

          google.maps.event.addListener(marker, 'click', function () {
            _this.slideToDeal(marker.id);
          });

          _this.markers.push(marker);
        })(i);
      }
      if (this.navigationType === "circle") {
        this.circleArea = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          map: _this.map,
          center: new google.maps.LatLng(this.userLocation[0], this.userLocation[1]),
          radius: radius
        });
      } else {
        if(this.nearByDeals.length){
          this.map.fitBounds(bounds);
        }
      }

    },

    _distance: function (lat, lon) {
      var radLatSrc = Math.PI * this.userLocation[0] / 180,
        radLatDest = Math.PI * lat / 180,
        theta = this.userLocation[1] - lon,
        radTheta = Math.PI * theta / 180,
        dist = Math.sin(radLatSrc) * Math.sin(radLatDest) + Math.cos(radLatSrc) * Math.cos(radLatDest) * Math.cos(radTheta);

      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      return dist
    },

    slideToDeal: function (id) {
      if (!this.$slider) {
        return;
      }
      this.$delasWrapper.parent().addClass('map-view__deals--open');
      this.$delasWrapper.find('.slide').removeClass('active');
      var slide = _.find(this.$slider.slides, function (slide) {
        return $(slide.element).data('id') == id;
      });
      $(slide.element).addClass('active');
      this.$slider.slideTo(this.$slider.position.end - slide.center)
    },

    initSlider: function () {
      if (this.$slider) {
        this.$slider.destroy();
      }

      if (!this.nearByDeals || !this.nearByDeals.length) {
        this.$delasWrapper.html('');
        return;
      }
      this.$delasWrapper.html(this.dealsTemplate({deals: this.nearByDeals}));

      var $carousel = this.$delasWrapper.find('.tkh-on-map__carousel'),
        $frame = $('.frame', $carousel);

      this.$slider = new mightySlider($frame, {
        speed: 1000,
        easing: 'easeOutExpo',
        viewport: 'fill',
        startAt: 0,
        navigation: {
          navigationType: 'basic',
          slideSize: this._calculateSlideSize(),
          isRtl: true
        },
        commands: {
          buttons: 1
        },
        dragging: {
          mouseDragging: 0,
          touchDragging: 0
        }
      }).init();
      window.$slider = this.$slider;
    },

    _calculateSlideSize: function () {
      if ($(window).width < 480) {
        return "300px"
      }
      return "380px";
    },

    toggleDeals: function (e) {
      e.preventDefault();
      this.$delasWrapper.parent().toggleClass('map-view__deals--open');
    },

    toggleFilters: function (e) {
      e.preventDefault();
      this.$filtersWrapper.toggleClass('map-view__filters--show');
    }

  })

});

